const ByteSizeDenomination = {
    bytes: 0,
    kilobytes: 1,
    megabytes: 2,
    gigabytes: 3,
    terabytes: 4,
    petabytes: 5,
};
const convertByteSizeValue = (original, toUnit) => {
    const baseDenomination = ByteSizeDenomination[original._type];
    const toDenomination = ByteSizeDenomination[toUnit];
    const powerDifference = baseDenomination - toDenomination;
    return original.value * 1024 ** powerDifference;
};
const toBytes = (value) => {
    return {
        _type: "bytes",
        value,
    };
};
const toKilobytes = (value) => {
    return {
        _type: "kilobytes",
        value,
    };
};
const toMegabytes = (value) => {
    return {
        _type: "megabytes",
        value,
    };
};
const toGigabytes = (value) => {
    return {
        _type: "gigabytes",
        value,
    };
};
const toTerabytes = (value) => {
    return {
        _type: "terabytes",
        value,
    };
};
const toPetabytes = (value) => {
    return {
        _type: "petabytes",
        value,
    };
};
const toConverters = {
    bytes: toBytes,
    kilobytes: toKilobytes,
    megabytes: toMegabytes,
    gigabytes: toGigabytes,
    terabytes: toTerabytes,
    petabytes: toPetabytes,
};
export const convertByteSize = (original, toUnit) => {
    const converter = toConverters[toUnit];
    const valueConverted = convertByteSizeValue(original, toUnit);
    return converter(valueConverted);
};
export const toByteType = (value, toUnit) => {
    return toConverters[toUnit](value);
};
export const addByteSizes = (a, b, toUnit) => {
    const aConverted = convertByteSize(a, toUnit);
    const bConverted = convertByteSize(b, toUnit);
    return toByteType(aConverted.value + bConverted.value, toUnit);
};
//# sourceMappingURL=bytes.js.map